import ModalPrompt from "@/app/components/ui/Modals/Prompt";
import { CheckBadgeIcon } from "@heroicons/react/20/solid";
import { MdSignalWifiStatusbarConnectedNoInternet2 } from "react-icons/md";

export interface INoInternetModalState {
  cacheFor: "EMR";
}

const NoInternetModal = () => {
  return (
    <ModalPrompt
      modalId="NO_INTERNET_MODAL"
      backdropBlur
      persistent
      button={{
        primaryButtonText: "Refresh",
        secondaryButtonText: "Cancel",
        shouldHideOnClick: false,
      }}
      title="Oops ! Internet Disconnected"
      showIcon
      titleIcon={
        <span className="text-2xl">
          <MdSignalWifiStatusbarConnectedNoInternet2 />
        </span>
      }
      content={
        <div className="w-full">
          <p>The internet has been disconnected, either connect and refresh the page or click on the refresh.</p>
          <ol className="mt-2">
            <li className="flex justify-start items-center text-xs">
              <span>
                <CheckBadgeIcon className="w-4 h-4 text-green-400" />
              </span>
            </li>
          </ol>
        </div>
      }
    />
    
  );
};

export default NoInternetModal;
